/**
 * Global Menu
 */
export function global_menu() {
  const nav = document.getElementById('global-nav');
  if (!nav) return;

  const items = Array.from(
    nav.querySelectorAll('.p-global-nav__inner > ul > li[data-has="has-submenu"]')
  );

  const plainItems = Array.from(
    nav.querySelectorAll('.p-global-nav__inner > ul > li:not([data-has="has-submenu"])')
  );

  const closeDelay = 250;
  const closeTimers = new Map();

  function clearCloseTimer(li) {
    const timerId = closeTimers.get(li);
    if (!timerId) return;

    window.clearTimeout(timerId);
    closeTimers.delete(li);
  }

  function openMenu(li) {
    clearCloseTimer(li);

    items.forEach((item) => {
      if (item !== li) {
        closeMenu(item);
      }
    });

    li.classList.add('is-select');

    const trigger = li.querySelector(':scope > a, :scope > span, :scope > button');
    trigger?.setAttribute('aria-expanded', 'true');
  }

  function closeMenu(li) {
    clearCloseTimer(li);

    li.classList.remove('is-select');

    const trigger = li.querySelector(':scope > a, :scope > span, :scope > button');
    trigger?.setAttribute('aria-expanded', 'false');
  }

  function scheduleCloseMenu(li) {
    clearCloseTimer(li);

    closeTimers.set(
      li,
      window.setTimeout(() => {
        closeMenu(li);
      }, closeDelay)
    );
  }

  items.forEach((li) => {
    const trigger = li.querySelector(':scope > a, :scope > span, :scope > button');
    if (!trigger) return;

    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');

    li.addEventListener('mouseenter', () => {
      openMenu(li);
    });

    li.addEventListener('mouseleave', (e) => {
      const nextTarget = e.relatedTarget;

      // 移動先が自分の中なら閉じない
      if (nextTarget instanceof Node && li.contains(nextTarget)) {
        return;
      }

      scheduleCloseMenu(li);
    });

    li.addEventListener('focusin', () => {
      openMenu(li);
    });

    li.addEventListener('focusout', (e) => {
      const nextTarget = e.relatedTarget;

      if (nextTarget instanceof Node && li.contains(nextTarget)) {
        return;
      }

      scheduleCloseMenu(li);
    });

    li.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeMenu(li);
        trigger.focus();
      }
    });

    const close = li.querySelector('.close');

    if (close) {
      close.addEventListener('click', () => {
        closeMenu(li);
        trigger.focus();
      });
    }
  });

  // サブメニューを持たないメニューに移動したときも、開いているメニューを遅延して閉じる
  plainItems.forEach((plainItem) => {
    plainItem.addEventListener('mouseenter', () => {
      items.forEach((item) => {
        if (item.classList.contains('is-select')) {
          scheduleCloseMenu(item);
        }
      });
    });
  });

  // 他エリアクリックで即時閉じる
  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target)) {
      items.forEach(closeMenu);
    }
  });
}

/**
 * Global Menu Current
 */
export function global_menu_current() {
  document.addEventListener('DOMContentLoaded', () => {
    const pageURLArr = location.pathname.split('/');
    const pageURLArrCategory = pageURLArr[1];

    const categoryToClassMap = {
      strengths: 'nav-strengths',
      business: 'nav-business',
      showroom: 'nav-showroom',
      company: 'nav-company',
      recruit: 'nav-recruit',
    };

    const targetClass = categoryToClassMap[pageURLArrCategory];

    if (targetClass) {
      const targetItem = document.querySelector(
        '.p-global-nav__inner > ul > li.' + targetClass
      );

      targetItem?.classList.add('is-current');
    }
  });
}